import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {PURGE} from "redux-persist/es/constants";

// Define a type for the slice state
export interface ChessState {
  playing: boolean
  moves: string[]
}

// Define the initial state using that type
const initialState: ChessState = {
  playing: false,
  moves: []
}

export const chessSlice = createSlice({
  name: 'chess',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setPlayingChess: (state, action: PayloadAction<boolean>) => {
      console.log('chess', action.payload);
      state.playing = action.payload
    },
    addChessMove: (state, action: PayloadAction<string>) => {
      state.moves = [
        ...state.moves,
        action.payload
      ]
    }
  }
})

export const { setPlayingChess, addChessMove } = chessSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectPlayingChess = (state: RootState) => state.chess.playing
export const selectChessMoves = (state: RootState) => state.chess.moves

export default chessSlice.reducer